import React from 'react';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

class RadioFormType extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            image: props.config.sample_image_path,
            description: ''
        };
    }

    componentDidMount(){
        //CHECK IF ALREADY CHECKED OPTION:

        const _this = this;

        if(this.props.checked != null){
            this.props.items.map(function(element) {

                if(element.value === _this.props.checked){
                    _this.changeImage(element.image);
                    _this.changeDescription(element.description);
                }

                return true;
            });
        }
    }

    changeImage(image) {
        this.setState({image: image});
    }

    changeDescription(description) {
        this.setState({description: description});
    }

    render() {
        return (
            <div>
                {this.state.description !== undefined && this.state.description !== '' && this.state.description !== null &&
                <p className="annotation radioFormType">{this.state.description}</p>
                }
                <div className="col-dt-50 col-tbl-full">
                    <RadioList elements={this.props.items} checked={this.props.checked} input_name={this.props.input_name} changeImage={(image) => this.changeImage(image)} changeDescription={(description) => this.changeDescription(description)} onTypeChanged={(value) => this.props.onTypeChanged(value)} />
                </div>
                <div className="col-dt-50 col-tbl-full">
                    <div className="img-container">
                        <img src={this.state.image} alt={this.props.input_name} />
                    </div>
                </div>
            </div>
        );
    }
}

class RadioList extends React.Component {

    render() {

        const _this = this;

        var sum_items = this.props.elements.length;

        var radioElements = this.props.elements.map(function(element) {

            var checked = false;
            var recommended = false;

            if(_this.props.checked !== null && _this.props.checked === element.value){
                checked = true;
            }

            if("recommended" in element && element.recommended === 1){
                recommended = true;
            }

            return (
                <RadioElement key={_this.props.input_name + element.value} checked={checked} input_name={_this.props.input_name} value={element.value} name={element.name} image={element.image} description={element.description}  changeImage={(image) => _this.props.changeImage(image)} changeDescription={(description) => _this.props.changeDescription(description)} onTypeChanged={(value) => _this.props.onTypeChanged(value)} recommended={recommended} sum_items={sum_items}/>
            );
        });

        return (
            <div className="neutrik-radio">
                {radioElements}
            </div>
        );
    }
}

class RadioElement extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            types: [],
            description: '',
            image: props.sample_image_path
        };
    }

    componentDidMount(){

        if(this.props.sum_items === 1 && !this.props.checked){
            this.checkItem({
                image: this.props.image,
                description: this.props.description,
                value: this.props.value
            });
        }
    }

    onValueChanged(e) {
        this.props.changeImage(this.props.image);
        this.props.changeDescription(this.props.description);
        this.props.onTypeChanged(this.props.value);
    }

    checkItem(item) {
        this.props.changeImage(item.image);
        this.props.changeDescription(item.description);
        this.props.onTypeChanged(item.value);
    }

    render() {
        return (
            <div className="neutrik-radio">

                <input type="radio" name={this.props.input_name} value={this.props.value} id={this.props.input_name + "_" + this.props.value} onChange={(e) => this.onValueChanged(e)} checked={this.props.checked}/>
                <label htmlFor={this.props.input_name + "_" + this.props.value}>{this.props.name}
                    {this.props.recommended &&
                        <div className="recommended">Recommended</div>
                    }
                </label>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    config: state.config
})

const mapDispatchToProps = dispatch => bindActionCreators({
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RadioFormType)


// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/components/RadioFormType.js